<div class="asset-details-root">
  <div class="asset-details-header">
    <div class="row">
      <div class="asset-header-info col-6">
        <div class="header-info-column">
          <div class="header-title">
            <b>{{ 'COMMON.MBC_DETAILS.BUILDING_SLRN' | translate }}</b>
          </div>
          <div class="header-info-line">
            <span class="light-gray-text">
              {{ selectedBuilding.slrn ? selectedBuilding.slrn : ('COMMON.NO_SLRN' | translate) }}
            </span>
            <span class="pill header-pill green-success-pill"
              *ngIf="selectedBuilding.dataQualityStatus != null && selectedBuilding.dataQualityStatus!.toString() == 'Approved'">
              {{ 'COMMON.ASSET_STATUS.COMPLETE' | translate }}
            </span>
            <span class="pill header-pill red-failure-pill"
              *ngIf="selectedBuilding.dataQualityStatus != null && selectedBuilding.dataQualityStatus!.toString() == 'Rejected'">
              {{ 'COMMON.ASSET_STATUS.REJECTED' | translate }}
            </span>
            <span class="pill header-pill" *ngIf="selectedBuilding.status && !selectedBuilding.dataQualityStatus"
              [ngClass]="{
                'light-gray-pill': selectedBuilding.status == 'Pending',
                'light-orange-pill': selectedBuilding.status == 'Assigned' || selectedBuilding.status == 'Retagged',
                'red-failure-pill': selectedBuilding.status == 'Rejected'
              }">
              {{ 'COMMON.ASSET_STATUS.' + selectedBuilding.status | uppercase | translate }}
            </span>
          </div>
        </div>
        <div class="header-info-column">
          <div class="light-gray-text">
            {{ selectedBuilding.address ? selectedBuilding.address : ('BUILDINGS.EDIT.NO_ADDRESS' | translate) }}
          </div>
          <div class="header-info-line light-gray-text" *ngIf="selectedBuilding.connectedCustomers.length > 0">
            {{ selectedBuilding.connectedCustomers[0].accountNumber }}
            <span class="pill asset-type-pill">{{ selectedBuilding.connectedCustomers[0].useOfPremises }}</span>
          </div>
        </div>
      </div>
      <div class="header-actions col">
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#history"
          *ngIf="selectedBuilding.buildingHistories.length > 0">
          {{ 'COMMON.HISTORY' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal"
          (click)="getMobileUsers(); setModalType(AssetAssignType.Retagged);" data-bs-target="#assignToFieldAgent"
          *ngIf="permissionsService.isBuildingRetagAllowed">
          {{ 'COMMON.RETAG' | translate }}
        </button>
        <div class="recall-container position-relative d-inline-block" *ngIf="
            permissionsService.isBuildingRecallAssignedAllowed ||
            permissionsService.isBuildingRecallValidatedAllowed
          ">
          <button class="btn asset-header-action-button" (click)="showRecallMenu = !showRecallMenu">
            {{ 'COMMON.RECALL' | translate }}
          </button>
          <div *ngIf="showRecallMenu" class="recall-options shadow-sm" @slideToggle>
            <div class="recall-type" [ngClass]="!recallAssignedAllowed ? 'recall-type-disabled' : 'recall-type-enabled'"
              (click)="recallAssignedAllowed ? recallAssigned() : null">
              <span>{{ 'COMMON.ASSIGNED_TASK' | translate }}</span>
            </div>
            <div class="recall-type" [ngClass]="!recallValidatedAllowed ? 'recall-type-disabled' : 'recall-type-enabled'"
              (click)="recallValidatedAllowed ? recallValidation() : null">
              <span>{{ 'COMMON.VALIDATED_TASK' | translate }}</span>
            </div>
          </div>
        </div>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#updateStatus"
          *ngIf="permissionsService.isBuildingApproveRejectAllowed" [disabled]="selectedBuilding.dataQualityStatus">
          {{ 'COMMON.UPDATE_STATUS' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#auditReview"
          [disabled]="disableAuditReviewButton()" *ngIf="permissionsService.isBuildingAuditReviewAllowed">
          {{ 'COMMON.FIELD_AUDIT' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#review"
          [disabled]="disableReviewButton()" *ngIf="permissionsService.isBuildingReviewAllowed">
          {{ 'COMMON.REVIEW_BUTTON' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#assignToFieldAgent"
          (click)="getMobileUsers(); setModalType(AssetAssignType.Assigned);"
          *ngIf="permissionsService.isBuildingAssignAllowed">
          {{ 'COMMON.ASSIGN_AGENT' | translate }}
        </button>
        <button class="btn asset-header-action-button" *ngIf="!editEnabled && permissionsService.isBuildingCreateEditAllowed"
          (click)="edit()">
          {{ 'COMMON.EDIT' | translate }}
        </button>
        <button class="btn asset-header-action-button asset-header-save-button" *ngIf="editEnabled" (click)="save()">
          {{ 'COMMON.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="asset-details-content">
    <div class="row">
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <div class="asset-card col-12"
          [ngClass]="buildingInfoCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'BUILDINGS.INFO' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="buildingInfoCardExpanded = !buildingInfoCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="buildingInfoCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="buildingInfoCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.PHYSICAL_ADDRESS' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('Address')">{{ selectedBuilding.address | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('Address')" class="form-control" [(ngModel)]="selectedBuilding.address" />
              </div>
            </div>
            <div class="asset-card-info row"
              *ngIf="!authService.hasCimDataIntegration && permissionsService.isBuildingElectricalAddressCodeAllowed">
              <div (click)="switchElectricalAddressFormat()" class="col-5 asset-card-content-title property-code-switch">
                {{ (isCinEnabled ? 'COMMON.MBC_DETAILS.CIN' : 'COMMON.MBC_DETAILS.ELECTRICAL_ADDRESS') | translate }}
              </div>
              <div class="col-7 asset-card-content-value">
                {{ (isElectricalAddressLong ? selectedBuilding.electricalAddressLong : selectedBuilding.electricalAddress) | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CLOSEST_LANDMARK' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('ClosestLandmark')">{{ selectedBuilding.closestLandmark | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('ClosestLandmark')" class="form-control" [(ngModel)]="selectedBuilding.closestLandmark" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.TABLE_HEADERS.BUILDING_OWNER' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('BuildingOwner')">{{ selectedBuilding.buildingOwner | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('BuildingOwner')" class="form-control" [(ngModel)]="selectedBuilding.buildingOwner" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'BUILDINGS.EDIT.COMMENT' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding.comment | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'BUILDINGS.EDIT.VISITS_NO' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding.numberOfRevisits | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.BUILDING_STRUCTURE.NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('BuildingStructure')">{{ selectedBuilding.buildingStructure | hasValue }}</ng-container>
                <select *ngIf="isStaticEditable('BuildingStructure')" class="form-control" [(ngModel)]="selectedBuilding.buildingStructure">
                  <option *ngFor="let option of structureOptions" [ngValue]="structure[option.key]">
                    {{ 'COMMON.MBC_DETAILS.BUILDING_STRUCTURE.' + option.value | uppercase | translate }}
                  </option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.BUILDING_DEVELOPMENT.NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('BuildingDevelopmentStage')">{{ selectedBuilding.buildingDevelopmentStage | hasValue }}</ng-container>
                <select *ngIf="isStaticEditable('BuildingDevelopmentStage')" class="form-control" [(ngModel)]="selectedBuilding.buildingDevelopmentStage">
                  <option *ngFor="let option of developmentStageOptions" [ngValue]="developmentStage[option.key]">
                    {{ option.value }}
                  </option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.NUMBER_OF_SERVICE_WIRES' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding.numberOfServiceWires | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.POLE.CONNECTED_LT_POLE' | translate }}</div>
              <div class="col-7 asset-card-content-value conn-assets">
                {{ selectedBuilding.poleSlrn | hasValue }}
                <img *ngIf="selectedBuilding?.poleId" (click)="viewConnectedAssets(1)" title="View"
                  src="assets/icons/angles-right.svg">
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.FEEDER_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isFeederEditable">{{ selectedBuilding.dt?.feeder?.name | hasValue }}</ng-container>
                <ng-container *ngIf="isFeederEditable">
                  <ng-container *ngIf="!authService.hasCimDataIntegration">
                    <select *ngIf="selectedBuilding.dt.feeder.id !== 0" class="form-control"
                      [(ngModel)]="selectedBuilding.feederId" (change)="selectFeeder()">
                      <option *ngFor="let option of f11Options" [ngValue]="option.id">{{ option.name }}</option>
                    </select>
                    <select *ngIf="selectedBuilding.dt.feeder.id !== 0" class="form-control"
                      [(ngModel)]="selectedBuilding.feederId" (change)="selectFeeder()">
                      <option *ngFor="let option of f33Options" [ngValue]="option.id">{{ option.name }}</option>
                    </select>
                  </ng-container>
                  <select *ngIf="authService.hasCimDataIntegration" class="form-control" (change)="selectAcLine($event)">
                    <option value="" [selected]="!selectedAcLineId" disabled hidden>
                      {{ 'COMMON.MBC_DETAILS.FEEDER_NAME' | translate }}
                    </option>
                    <option *ngFor="let l of acLines" [selected]="selectedAcLineId === l.id" [value]="l.id">{{ l.name }}</option>
                  </select>
                </ng-container>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.FEEDER_NUMBER' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding.dt?.feeder?.number | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.DT_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('DtName')">{{ selectedBuilding.dt?.name | hasValue }}</ng-container>
                <ng-container *ngIf="isStaticEditable('DtName')">
                  <select *ngIf="!authService.hasCimDataIntegration" required class="form-control"
                    [(ngModel)]="selectedBuilding.dtId">
                    <option hidden selected>{{ 'TRANSFORMERS.SELECT' | translate }}</option>
                    <option *ngFor="let option of dtOptions" [ngValue]="option.key">{{ option.value }}</option>
                  </select>
                  <select *ngIf="authService.hasCimDataIntegration" required class="form-control"
                    (change)="selectSubstation($event)">
                    <option value="" [selected]="!selectedBuilding.substationId" disabled hidden>
                      {{ 'COMMON.DT_NAME' | translate }}
                    </option>
                    <option *ngFor="let s of selectableSubstations" [selected]="selectedBuilding.substationId === s.id"
                      [value]="s.id">{{ s.name }}</option>
                  </select>
                </ng-container>
              </div>
            </div>
            <div class="asset-card-info row" *ngIf="selectedBuilding && selectedBuilding.upriserName !== ''">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.UPRISER' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding?.upriserName | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="selectedBuilding.propertyCode != ''">
              <div (click)="switchPropertyCodeFormat()" class="col-5 asset-card-content-title property-code-switch">
                {{ 'COMMON.MBC_DETAILS.PROPERTY_CODE' | translate }}
              </div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!editEnabled">
                  {{ (isPropertyCodeShort ? selectedBuilding.propertyCodeShort : selectedBuilding.propertyCode) | hasValue }}
                </ng-container>
                <input *ngIf="editEnabled" class="form-control" [(ngModel)]="selectedBuilding.propertyCode" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.BU.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding.regionName | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.UT.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding.areaName | hasValue }}</div>
            </div>
            <ng-container *ngIf="isGhanaPostFieldsVisible">
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.GHANA_POST_GPS' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ selectedBuilding.postCode | hasValue }}</div>
              </div>
              <div class="asset-card-info row" *ngIf="selectedBuilding.postCodeException">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.GHANA_POST_GPS_EXC' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ selectedBuilding.postCodeException | hasValue }}</div>
              </div>
            </ng-container>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'BUILDINGS.EDIT.GEO_COORDINATES' | translate }}</div>
              <div class="col-6 asset-card-content-value">
                {{ selectedBuilding.latitude }}, {{ selectedBuilding.longitude }}
              </div>
              <div class="geo-icon col-1" (click)="showBuildingLocation()" data-bs-toggle="modal" data-bs-target="#showMap">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 0C8.30376 0 8.55479 0.225723 8.59452 0.518583L8.6 0.6L8.59925 2.03017C11.4343 2.31006 13.6899 4.56575 13.9706 7.40203L14 7.4H15.4C15.7314 7.4 16 7.66863 16 8C16 8.30376 15.7743 8.55479 15.4814 8.59452L15.4 8.6L13.9693 8.59923C13.6899 11.4343 11.4343 13.6899 8.59797 13.9706L8.6 14V15.4C8.6 15.7314 8.33137 16 8 16C7.69624 16 7.44521 15.7743 7.40548 15.4814L7.4 15.4L7.40077 13.9693C4.56575 13.6899 2.31006 11.4343 2.02942 8.59797L2 8.6H0.6C0.268629 8.6 0 8.33137 0 8C0 7.69624 0.225723 7.44521 0.518583 7.40548L0.6 7.4L2.03017 7.40075C2.31006 4.56575 4.56575 2.31006 7.40203 2.02942L7.4 2V0.6C7.4 0.268629 7.66863 0 8 0ZM8 3.2C5.34903 3.2 3.2 5.34903 3.2 8C3.2 10.651 5.34903 12.8 8 12.8C10.651 12.8 12.8 10.651 12.8 8C12.8 5.34903 10.651 3.2 8 3.2ZM8 4.8C9.76731 4.8 11.2 6.23269 11.2 8C11.2 9.76731 9.76731 11.2 8 11.2C6.23269 11.2 4.8 9.76731 4.8 8C4.8 6.23269 6.23269 4.8 8 4.8Z"
                    fill="var(--primary-color)" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="asset-card col-12"
          [ngClass]="connectedAccountsCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'BUILDINGS.CONNECTED_ACCS' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="connectedAccountsCardExpanded = !connectedAccountsCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="connectedAccountsCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="connectedAccountsCardExpanded && selectedBuilding.connectedCustomers.length > 0"
            class="asset-card-content" @slideToggle>
            <table class="connected-customers-table">
              <thead>
                <tr>
                  <th>{{ 'COMMON.MBC_DETAILS.CUSTOMER_NAME' | translate }}</th>
                  <th>{{ 'COMMON.TABLE_HEADERS.BUILDING_OWNER' | translate }}</th>
                  <th>{{ 'COMMON.MBC_DETAILS.METER_NO' | translate }}</th>
                  <th>{{ 'COMMON.MBC_DETAILS.ACCOUNT_NO' | translate }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let customer of selectedBuilding.connectedCustomers">
                  <td [title]="customer.tenantName">{{ customer.tenantName | hasValue }}</td>
                  <td [title]="customer.buildingOwner">{{ customer.buildingOwner | hasValue }}</td>
                  <td [title]="customer.meterNumber">{{ customer.meterNumber | hasValue }}</td>
                  <td [title]="customer.accountNumber">{{ customer.accountNumber | hasValue }}</td>
                  <td class="status-cell">
                    <span *ngIf="customer.dataQualityId == 0" class="pending" (click)="navigateToCustomer(customer)">
                      <svg fill="gray" height="1em" viewBox="0 0 640 512">
                        <path
                          d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z" />
                      </svg>
                    </span>
                    <span *ngIf="customer.dataQualityId != 0 && customer.dataQualityStatus == 'Approved'" class="approved">
                      <svg fill="#00875A" height="1em" viewBox="0 0 640 512">
                        <path
                          d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                      </svg>
                    </span>
                    <span *ngIf="customer.dataQualityId != 0 && customer.dataQualityStatus == 'Rejected'" class="rejected">
                      <svg fill="#DE350B" height="1em" viewBox="0 0 640 512">
                        <path
                          d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                      </svg>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="selectedBuilding.customerInaccessible" class="asset-card asset-card-expanded col-12">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-12">{{ 'BUILDINGS.EDIT.ACCESSIBILITY_ISSUE' | translate }}</h2>
          </div>
          <div class="asset-card-content">
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.REASON' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding.customerInaccessible.issueKind | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="selectedBuilding.customerInaccessible.issueKind === 'Other'">
              <div class="col-5 asset-card-content-title">{{ 'BUILDINGS.EDIT.ISSUE_TYPE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding.customerInaccessible.issueType | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'BUILDINGS.EDIT.REMARK' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedBuilding.customerInaccessible.description | hasValue }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="selectedBuilding.inaccessibleMeters.length > 0" class="asset-card asset-card-expanded col-12">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-12">{{ 'BUILDINGS.INACCESSIBLE_METERS' | translate }}</h2>
          </div>
          <div class="asset-card-content inaccessible-meters">
            <div class="asset-card-info row" *ngFor="let inaccessible of selectedBuilding.inaccessibleMeters">
              <div class="col-5 asset-card-content-title">{{ inaccessible.number }}</div>
              <div class="col-7 asset-card-content-value">
                <img *ngIf="inaccessible.meterImage != undefined" src="{{ inaccessible.meterImage.url }}"
                  (click)="showInaccessibleImage(inaccessible.meterImage)" data-bs-toggle="modal"
                  data-bs-target="#modalImage" alt="Meter image" />
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="isDataQuality && selectedBuilding.dataValidationReview != null && selectedBuilding.dataValidationReview.length > 0"
          class="asset-card asset-card-expanded col-12">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-12">{{ 'COMMON.DATA_VALID_REVIEW' | translate }}</h2>
          </div>
          <div class="asset-card-content">
            <div class="asset-card-info row" *ngFor="let dq of selectedBuilding.dataValidationReview">
              <div class="col-5 asset-card-content-title">{{ dq.key }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="dq.key != 'Reason for rejection'">{{ dq.value | hasValue }}</ng-container>
                <a *ngIf="dq.key == 'Reason for rejection'" class="link" data-bs-toggle="modal"
                  data-bs-target="#rejectionReason">{{ 'COMMON.VIEW' | translate | lowercase }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Column 2: Meter Information, User Activity, Images -->
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <div class="asset-card col-12"
          [ngClass]="meterInfoCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'COMMON.MBC_DETAILS.METER_INFO' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="meterInfoCardExpanded = !meterInfoCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="meterInfoCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="meterInfoCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">{{ 'BUILDINGS.EDIT.METER_NO' | translate }}</div>
              <div class="col-5 asset-card-content-value">
                {{ selectedBuilding.connectedCustomers.length ? (selectedBuilding.numberOfMeters | number) : '----' }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_STATUS' | translate }}</div>
              <div class="col-5 asset-card-content-value">
                {{ selectedBuilding.connectedCustomers.length ? (renderMeterStatus() ? 'Metered' : 'Unmetered') : '----' }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CONNECTED_CUSTOMERS' | translate }}</div>
              <div class="col-5 asset-card-content-value">
                {{ selectedBuilding.connectedCustomers.length ? (selectedBuilding.connectedCustomers.length | number) : '----' }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-7 asset-card-content-title">{{ 'BUILDINGS.INACCESSIBLE_METERS' | translate }}</div>
              <div class="col-5 asset-card-content-value">
                {{ selectedBuilding.inaccessibleMeters.length ? (selectedBuilding.inaccessibleMeters.length | number) : '----' }}
              </div>
            </div>
          </div>
        </div>

        <div class="asset-card col-12"
          [ngClass]="userActivityCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'MV_POLES.USER_ACTIVITY' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="userActivityCardExpanded = !userActivityCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="userActivityCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="userActivityCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.FIRST_CAPTURED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedBuilding.firstCapturedUser | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.LAST_CAPTURED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedBuilding.lastUpdatedUser | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.CREATION_DATE' | translate }}</div>
              <div class="col-6 asset-card-content-value">
                {{ selectedBuilding.creationDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.UPDATED_DATE' | translate }}</div>
              <div class="col-6 asset-card-content-value">
                {{ selectedBuilding.updatedDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.REASSIGNED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedBuilding.reassignedBy | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.ASSIGNED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedBuilding.assignedUser | hasValue }}</div>
            </div>
            <ng-container *ngIf="permissionsService.isValidationStatusAllowed">
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.VALIDATION_STATUS' | translate }}</div>
                <div class="col-6 asset-card-content-value">
                  <ng-container *ngIf="selectedBuilding.dataQualityStatus?.toString() == 'Approved'">
                    {{ 'COMMON.ASSET_STATUS.COMPLETE' | translate }}
                  </ng-container>
                  <ng-container *ngIf="selectedBuilding.dataQualityStatus?.toString() == 'Rejected'">
                    {{ 'COMMON.ASSET_STATUS.REJECTED' | translate }}
                  </ng-container>
                  <ng-container *ngIf="selectedBuilding.status && !selectedBuilding.dataQualityStatus">
                    {{ 'COMMON.ASSET_STATUS.' + selectedBuilding.status | uppercase | translate }}
                  </ng-container>
                  <ng-container *ngIf="!selectedBuilding.status && !selectedBuilding.dataQualityStatus">--------</ng-container>
                </div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.VALIDATED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedBuilding.validatedBy | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.DATE_TYPE.VALIDATED' | translate }}</div>
                <div class="col-6 asset-card-content-value">
                  {{ selectedBuilding.validatedDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="permissionsService.isAuditStatusAllowed">
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.AUDITED_STATUS' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedBuilding.auditedStatus | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.AUDITED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedBuilding.auditedBy | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.AUDITED_DATE' | translate }}</div>
                <div class="col-6 asset-card-content-value">
                  {{ selectedBuilding.auditedDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="permissionsService.isReviewStatusAllowed">
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.REVIEW_STATUS' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedBuilding.reviewStatus | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.REVIEWED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedBuilding.reviewedBy | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.REVIEW_DATE' | translate }}</div>
                <div class="col-6 asset-card-content-value">
                  {{ selectedBuilding.reviewDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="asset-card col-12" [ngClass]="imagesCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-10">{{ 'COMMON.IMAGES' | translate }}</h2>
            <div class="collapse-arrow col-2">
              <button class="action-button" (click)="imagesCardExpanded = !imagesCardExpanded">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [attr.d]="imagesCardExpanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <div *ngIf="imagesCardExpanded" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-12 asset-card-content-title">{{ 'COMMON.PICTURES.FRONT' | translate }}</div>
              <div class="col-12 images-list">
                <app-image-section
                  *ngFor="let index of [0,1,2]"
                  [image]="getFrontViewImage(index)"
                  [index]="index"
                  [imageType]="ImageType.Frontview"
                  [editEnabled]="isStaticEditable('FrontViewPictures')"
                  [permission]="permissionsService.isBuildingCreateEditAllowed"
                  [inputId]="'fileFw' + index"
                  (imageClick)="showImage(ImageType.Frontview, index)"
                  (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-12 asset-card-content-title">{{ 'COMMON.PICTURES.BUILDING_TAG' | translate }}</div>
              <div class="col-12 images-list single-image-list">
                <app-image-section
                  [image]="getBuildingMountedImage()"
                  [index]="0"
                  [imageType]="ImageType.MountedTag"
                  [editEnabled]="isStaticEditable('BuildingTagMountedPicture')"
                  [inputId]="'fileMounted' + 0"
                  [permission]="permissionsService.isBuildingCreateEditAllowed"
                  (imageClick)="showImage(ImageType.MountedTag)"
                  (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Column 3: dynamic sections -->
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <lib-section-instance-card *ngFor="let section of sectionInstances" [section]="section"
          [editEnabled]="editEnabled" [editableAttributeIds]="editableAttributeIds" [editedValues]="editedValues"
          (mapClicked)="setClickedLocation($event)">
        </lib-section-instance-card>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="assignToFieldAgent" tabindex="-1" aria-hidden="true"
  (hidden.bs.modal)="onModalAssignFade()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="assetAssignType == AssetAssignType.Assigned" class="modal-title">{{ 'COMMON.ASSIGN_AGENT' | translate }}</h5>
        <h5 *ngIf="assetAssignType == AssetAssignType.Retagged" class="modal-title">{{ 'COMMON.RETAG_TASK' | translate }}</h5>
        <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
      <div class="modal-body">
        <div class="form-floating form-item">
          <input #userFilterInput autocomplete="off" type="text" name="filterText" [(ngModel)]="filterText"
            class="form-control filter-field" [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }" id="floatingInput"
            (ngModelChange)="filterMobileUsers()" (click)="openDropdown()" placeholder=" " />
          <label for="floatingInput">{{ 'COMMON.FIELD_AGENT' | translate }}</label>

          <div class="filtered-agent-list" *ngIf="isDropdownOpened" #dropdownContainer>
            <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)" *ngFor="let u of mobileUsers">
              {{ u.fullName }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="assignTask()">
          <span *ngIf="assetAssignType == AssetAssignType.Assigned">{{ 'COMMON.ASSIGN_TASK' | translate }}</span>
          <span *ngIf="assetAssignType == AssetAssignType.Retagged">{{ 'COMMON.RETAG_TASK' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showImageMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isImageMapVisible" [longitude]="selectedImage?.longitude"
          [latitude]="selectedImage?.latitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
  (shown.bs.modal)="onModalOpen()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-image">
      <div class="modal-body modal-body-image">
        <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
          <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage?.url" [thumbImage]="selectedImage?.url"
            [magnification]="3">
          </lib-ngx-image-zoom>
        </div>
        <div class="rotate-div">
          <button class="btn btn-primary left-button" (click)="rotateLeft()">&lt;</button>
          <button class="btn btn-primary right-button" (click)="rotateRight()">&gt;</button>
        </div>
        <app-image-geo-info [image]="selectedImage"
          (mapClicked)="isImageMapVisible = !isImageMapVisible"></app-image-geo-info>
      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isMapVisible" [longitude]="mapLongitude"
          [latitude]="mapLatitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="updateStatus" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.DATA_VALID_REVIEW' | translate }}</h5>
        <button type="button" #closeDQModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
      <div class="modal-body">
        <app-data-quality assetType="Building" (closeRedirectModal)="closeRedirectModal()"
          [updateStatusDisabled]="!updateStatusDisabled" [assetId]="selectedBuilding.id"
          [areaId]="selectedBuilding.areaId"></app-data-quality>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="auditReview" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.FIELD_AUDIT' | translate }}</h5>
        <button type="button" #closeAudit class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
      <app-audit-review (closeModal)="cancel()" assetType="Building" [assetId]="selectedBuilding.id"
        [areaId]="selectedBuilding.areaId" [fieldAuditDisabled]="fieldAuditDisabled"></app-audit-review>
    </div>
  </div>
</div>

<div class="modal" id="rejectionReason" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.REASON_FOR_REJECT' | translate }}</h5>
      </div>
      <div class="p-4">{{ modalRejectionReason }}</div>
      <button type="button" class="btn btn-primary w-50 mx-auto" data-bs-dismiss="modal" aria-label="Close">
        {{ 'COMMON.CLOSE' | translate }}
      </button>
    </div>
  </div>
</div>

<div class="modal" id="review" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.REVIEW' | translate }}</h5>
        <button type="button" #closeReviewModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
      <app-review (closeModal)="cancelReviewModal($event)" assetType="Building"
        [assetId]="selectedBuilding.id"></app-review>
    </div>
  </div>
</div>

<div class="modal fade" id="history" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered history-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.HISTORY' | translate }}</h5>
        <button type="button" class="btn-cancel-modal" data-bs-dismiss="modal">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
      <div class="container-fluid border-bottom">
        <table>
          <tr class="header-row">
            <th>{{ 'HISTORY.TIMESTAMP_DATE' | translate }}</th>
            <th>{{ 'ANOMALY.OPERATOR' | translate }}</th>
            <th>{{ 'COMMON.ASSET_HISTORIES.SLRNS' | translate }}</th>
            <th>{{ 'COMMON.ASSET_HISTORIES.FEEDER_NAME' | translate }}</th>
            <th>{{ 'COMMON.ASSET_HISTORIES.ADDRESSES' | translate }}</th>
            <th>{{ 'COMMON.ASSET_HISTORIES.DT_NAME' | translate }}</th>
            <th>{{ 'COMMON.PREVIOUS_CUSTOMERS' | translate }}</th>
            <th>{{ 'COMMON.TABLE_HEADERS.AREA' | translate }}</th>
            <th>{{ 'COMMON.BU.SINGLE' | translate }}</th>
          </tr>
          <tr class="content-wrapper" *ngFor="let item of selectedBuilding.buildingHistories">
            <td>{{ item.lastUpdateTime | date:'short' | hasValue }}</td>
            <td>{{ item.operatorName | hasValue }}</td>
            <td>{{ item.previousBuildingSlrn | historiesHasValue }}</td>
            <td>{{ item.previousFeederName | historiesHasValue }}</td>
            <td>{{ item.previousPhysicalAddress | historiesHasValue }}</td>
            <td>{{ item.previousDtName | historiesHasValue }}</td>
            <td [innerHTML]="item.previousCustomers | historiesHasValue"></td>
            <td>{{ item.areaName | historiesHasValue }}</td>
            <td>{{ item.regionName | historiesHasValue }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
